module.exports = __webpack_public_path__ + "assets/img/shortsPlatform-terminals.eb554184.png";